export const getDualLayoutCount = () => {
    return 49;
};
